import * as actionTypes from '../../scheduleDetails.actionTypes';
import { HIDE_LOADER, SHOW_LOADER } from '../../../../constants/actionTypes';

const initialState = {
  isLoading: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.CANCEL_CLONED_SCHEDULE_SUCCESS:
      return Object.assign({}, state, action.payload);
    case SHOW_LOADER:
      switch (action.payload) {
        case actionTypes.CANCEL_CLONED_SCHEDULE:
          return Object.assign({}, state, { isLoading: true });
        default:
          return Object.assign({}, state);
      }
    case HIDE_LOADER:
      switch (action.payload) {
        case actionTypes.CANCEL_CLONED_SCHEDULE:
          return Object.assign({}, state, { isLoading: false });
        default:
          return Object.assign({}, state);
      }
    default:
      return state;
  }
}
